import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem 0.5rem',
    cursor: 'pointer',
    color: '#323436'
  },

  rootActive: {
    '& svg': {
      filter:
        'invert(58%) sepia(80%) saturate(5283%) hue-rotate(261deg) brightness(87%) contrast(82%)'
    }
  },

  icon: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: theme.size.base,
    color: '#000000'
  },

  iconActive: {
    color: 'white'
  },

  title: {
    marginTop: '0.5rem',
    fontSize: theme.size.sm,
    textAlign: 'center',
    userSelect: 'none'
  },

  titleActive: {
    color: theme.palette.primary.main
  },

  dot: {
    position: 'absolute',
    top: '-11px',
    right: '-17px',
    backgroundColor: '#EB5757',
    border: 'solid 1.5px white'
  }
}))

export default useStyles
